import { Link } from 'react-router-dom';
import { Button } from './ui/button';

export const HeroSection = ({ onRequestQuote }) => {
  const heroSrc = `${process.env.PUBLIC_URL || ''}/hero_7.jpeg`;
  const heroMobileSrc = `${process.env.PUBLIC_URL || ''}/hero_7_mobile.jpeg`;
  const heroFactSrc = `${process.env.PUBLIC_URL || ''}/fact_pics.png`;

  const title = (
    <h1 className="text-2xl font-semibold tracking-tight text-[#1F2933] leading-[1.15] sm:text-3xl md:text-4xl lg:text-5xl">
      Custom Cotton Canvas, Jute &amp; Promotional Bags
    </h1>
  );
  const subtitle = (
    <p className="text-[#5A5A5A] text-sm sm:text-base leading-relaxed max-w-lg">
      Designed for brands, retailers, wineries, coffee companies, and corporate promotions.
      Custom manufacturing, consistent quality, and dependable delivery.
    </p>
  );
  const companyIntro = (
    <p className="text-[#1F2933] text-base sm:text-lg font-bold leading-snug max-w-lg">
      Bags4Ever Inc. is a U.S. company with manufacturing and sourcing operations in India,
      providing door-delivered custom bag solutions across the United States.
    </p>
  );
  const ctas = (
    <div className="flex flex-col space-y-3 md:flex-row md:gap-3 md:space-y-0 md:pt-2">
      <Button
        asChild
        className="w-full md:w-auto bg-green-700 hover:bg-green-800 text-white rounded-xl py-3 shadow-md text-sm font-medium transition-all duration-200"
        data-testid="shop-collection-btn"
      >
        <Link to="/collection">View Collection</Link>
      </Button>
      <Button
        onClick={onRequestQuote}
        variant="outline"
        className="w-full md:w-auto border border-green-700 text-green-700 rounded-xl py-3 hover:bg-green-50 transition-all duration-200 bg-transparent md:border-[#2F4F3E] md:text-[#2F4F3E] md:hover:bg-[#2F4F3E] md:hover:text-white"
        data-testid="wholesale-inquiry-btn"
      >
        Wholesale Inquiry
      </Button>
    </div>
  );

  return (
    <>
      {/* HERO BANNER – image only, no overlay */}
      <section className="w-full bg-[#F5F2ED] relative border-b border-gray-200 md:border-b-0" id="home" data-testid="hero-section">
        <div className="w-full">
          <img
            src={heroSrc}
            alt="Bags4Ever Sustainable Bags"
            className="hidden md:block w-full h-auto"
            loading="eager"
            fetchPriority="high"
            data-testid="hero-image"
          />
          <img
            src={heroMobileSrc}
            alt="Bags4Ever Sustainable Bags"
            className="md:hidden w-full h-auto max-h-[320px] object-cover block"
            loading="eager"
            fetchPriority="high"
            data-testid="hero-image-mobile"
          />
        </div>
      </section>

      {/* Hero content – below banner: two columns so right side is filled */}
      <section className="w-full bg-[#F5F2ED] border-b border-gray-200">
        <div className="max-w-7xl mx-auto w-full px-5 py-10 sm:py-12 md:py-14 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="flex flex-col space-y-4 sm:space-y-5">
              {title}
              {subtitle}
              {companyIntro}
              {ctas}
            </div>
            <div className="flex justify-center md:justify-end">
              <img
                src={heroFactSrc}
                alt="Bags4Ever sustainable manufacturing"
                className="w-full max-w-md lg:max-w-lg h-auto rounded-xl shadow-lg object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
